<template>
  <div v-if="nodeId === -1 || nodeId === '-1'" class="section-container">
    <no-permission-section />
  </div>
  <div v-else class="section-component">
    <div v-if="loading" class="section-loading">
      <div class="loading-spinner-small"></div>
      <span>Cargando resumen...</span>
    </div>
    
    <div v-else-if="error" class="section-error">
      <span class="material-icons-outlined">error_outline</span>
      <span>{{ error }}</span>
    </div>
    
    <div v-else class="section-content">
      <h4 class="node-title">{{ node.title }}</h4>
      
      <div class="resumen-content">
        <div v-if="node.content" class="node-body resumen-text" v-html="node.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import APICaller from '@/shared/mixins/APICaller.js';
import NoPermissionSection from './NoPermissionSection.vue';

export default {
  name: 'ResumenSection',
  components: {
    NoPermissionSection
  },
  mixins: [APICaller],
  props: {
    nodeId: {
      type: [Number, String],
      required: true
    },
    sectionType: {
      type: String,
      default: 'resumen'
    }
  },
  data() {
    return {
      node: null,
      loading: true,
      error: null
    };
  },
  mounted() {
    this.fetchNodeData();
  },
  methods: {
    fetchNodeData() {
      this.loading = true;
      this.error = null;
      
      let success = response => {
        this.node = response.data;
        this.loading = false;
      };
      
      let url = `/api/node/${this.nodeId}`;
      
      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('403', 'Error al cargar el resumen', error => {
        if (error.response && error.response.data && error.response.data.error) {
          this.error = error.response.data.error;
        } else {
          this.error = 'No se pudo cargar el contenido';
        }
        this.loading = false;
      });
      
      this._getAPICall(url, successHandler, failureHandler);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './CommonStyles.scss';

.section-container {
  width: 100%;
}

.resumen-content {
  margin-top: 16px;
}

.resumen-text {
  font-size: 16px;
  line-height: 1.8;
  
  p:first-of-type {
    font-weight: 500;
    font-size: 1.1em;
  }
}
</style> 